<template>
  <simple-dialog ref="dlg" title="Registration Details" width="700" :hideConfirmButton="true" cancelButtonText="Close">
    <template v-slot:content>
      <template v-if="detail">
        <v-row dense>
          <v-col cols="6"><strong>ITS ID:</strong> {{ detail.itsId }}</v-col>
          <v-col cols="6"><strong>Name:</strong> {{ detail.fullName }}</v-col>
          <v-col cols="6"><strong>Organization:</strong> {{ detail.organizationName }}</v-col>
          <v-col cols="6"><strong>Status:</strong> {{ detail.status }}</v-col>
          <v-col cols="6"><strong>Registration Amount:</strong> {{ detail.registrationCommitmentAmount }}</v-col>
          <v-col cols="6"><strong>Niaz Amount:</strong> {{ detail.niazCommitment }}</v-col>
        </v-row>
        <v-divider class="my-3" />
        <div class="text-subtitle-2 mb-2">Travel Details</div>
        <v-row dense>
          <v-col cols="6"><strong>Arrival:</strong> {{ formatDate(detail.arrivalDate) }}</v-col>
          <v-col cols="6"><strong>Departure:</strong> {{ formatDate(detail.departureDate) }}</v-col>
          <v-col cols="6"><strong>Visa:</strong> {{ detail.hasVisa == null ? '-' : (detail.hasVisa ? 'Yes' : 'No') }}</v-col>
          <v-col cols="6"><strong>Accommodation:</strong> {{ detail.accommodationType || '-' }}</v-col>
          <v-col cols="12" v-if="detail.accommodationAddress"><strong>Address:</strong> {{ detail.accommodationAddress }}</v-col>
          <v-col cols="6"><strong>Flight Booked:</strong> {{ detail.flightBooked == null ? '-' : (detail.flightBooked ? 'Yes' : 'No') }}</v-col>
          <v-col cols="6" v-if="detail.flightBooked"><strong>Carrier:</strong> {{ detail.flightCarrier }}</v-col>
          <v-col cols="6" v-if="detail.flightBooked"><strong>Flight No:</strong> {{ detail.flightNumber }}</v-col>
        </v-row>
        <v-divider class="my-3" v-if="detail.rejectionReason" />
        <div v-if="detail.rejectionReason"><strong>Rejection Reason:</strong> {{ detail.rejectionReason }}</div>

        <template v-if="detail.surveyResponses?.length">
          <v-divider class="my-3" />
          <div class="text-subtitle-2 mb-2">Survey responses</div>
          <div
            v-for="survey in detail.surveyResponses"
            :key="survey.surveyId"
            class="mb-4"
          >
            <div class="font-weight-medium mb-1">
              {{ survey.surveyTitle }}
              <span class="text-caption text-medium-emphasis">({{ survey.timing }})</span>
            </div>
            <v-row dense>
              <v-col
                cols="12"
                v-for="ans in survey.answers"
                :key="ans.questionId"
              >
                <strong>{{ ans.questionText }}:</strong>
                {{ ans.answer || "-" }}
              </v-col>
            </v-row>
          </div>
        </template>
      </template>
    </template>
  </simple-dialog>
</template>

<script setup>
import { ref, inject } from "vue";
import moment from "moment";
import { getRegistrationDetail } from "@/services/miqaatService";

const loader = inject("loader");
const snackbar = inject("snackBar");

const dlg = ref(null);
const detail = ref(null);

function formatDate(value) {
  return value ? moment(value).format("D-MMM-yyyy") : "-";
}

async function show(registrationId) {
  loader.show();
  try {
    detail.value = await getRegistrationDetail(registrationId);
    dlg.value.show();
  } catch (error) {
    snackbar.error(error);
  } finally {
    loader.hide();
  }
}

defineExpose({ show });
</script>
